import src from "IMAGE";
export default { src, width: 500, height: 123, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42i2KMQoAIAwD+x6nuriI/kl8gfjnUmgHI2QIR3KRiLjuvsGRmQWpTMM2BfKY2ULpPOiXpD696DNb03QQDwAAAABJRU5ErkJggg=="};
